import type { TeamsStore } from './interfaces'

export const actions = {
  setLoading (this: TeamsStore, payload: TeamsStore['loading']): void {
    this.loading = payload
  },
  setSaving (this: TeamsStore, payload: TeamsStore['saving']): void {
    this.saving = payload
  },
  setTeams (this: TeamsStore, payload: TeamsStore['teams']): void {
    this.teams = payload
  },
  setMeta (this: TeamsStore, payload: TeamsStore['meta']): void {
    this.meta = payload
  },
  setUsers (this: TeamsStore, payload: TeamsStore['users']): void {
    this.users = payload
  },
  setFilterSearch (this: TeamsStore, payload: TeamsStore['filterSearch']): void {
    this.filterSearch = payload
  },
  setCurrentPage (this: TeamsStore, payload: TeamsStore['currentPage']): void {
    this.currentPage = payload
  },
  setPerPage (this: TeamsStore, payload: TeamsStore['perPage']): void {
    this.perPage = payload
  },
  setTeamToDelete (this: TeamsStore, payload: TeamsStore['teamToDelete']): void {
    this.teamToDelete = payload
  },
  setCurrentTeam (this: TeamsStore, payload: TeamsStore['currentTeam']): void {
    this.currentTeam = payload
  },
  setModalCreate (this: TeamsStore, payload: TeamsStore['isModalCreate']): void {
    this.isModalCreate = payload
  },
  resetFilters (this: TeamsStore): void {
    this.filterSearch = null
    this.currentPage = 1
  },
}
